<template>
  <div class="ServicePackage-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-dropdown
          id="dropdown-right dropdown-form"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider> </b-dropdown-divider>
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Mã"
                    placeholder="Nhập mã"
                    name="code"
                    :value.sync="filter.code"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Tên"
                    placeholder="Nhập tên"
                    name="name"
                    :value.sync="filter.name"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Cấp độ"
                    placeholder="Nhập cấp độ"
                    name="level"
                    :value.sync="filter.level"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Giá tiền"
                    placeholder="Nhập giá tiền"
                    name="money"
                    :value.sync="filter.money"
                  >
                  </basic-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Số lượng chương trình"
                    placeholder="Nhập số lượng"
                    name="numberProgram"
                    :value.sync="filter.numberProgram"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Số tuần"
                    placeholder="Nhập số tuần"
                    name="totalWeek"
                    :value.sync="filter.totalWeek"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    name="status"
                    :options="status"
                    :value.sync="filter.status"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider> </b-dropdown-divider>
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="resetRequest"
            >
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="searchRequest"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="createItem"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="importItems"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
          </span>
          Import
        </b-button>
        <modal-import @import-success="loadData(true)" />
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ServicePackage-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td :class="getPositionClass('code')">
                      {{ item.code }}
                    </td>
                    <td :class="getPositionClass('name')">
                      {{ item.name }}
                    </td>
                    <td :class="getPositionClass('level')">
                      {{ item.level }}
                    </td>
                    <td :class="getPositionClass('money')">
                      {{ Number(item.money).toLocaleString('vi-VN') }} đ
                    </td>
                    <td :class="getPositionClass('numberProgram')">
                      {{ item.numberProgram }} Chương trình
                    </td>
                    <td :class="getPositionClass('totalWeek')">
                      {{ item.totalWeek }} Tuần
                    </td>
                    <td style="text-align: -webkit-center">
                      <div class="status" :class="getStatus(item.status)">
                        {{ item.status == 0 ? 'Hoạt động' : 'Không hoạt động' }}
                      </div>
                    </td>
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_edit="isUpdatePermission"
                        :show_delete="false"
                        :show_copy="false"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                        @edit="editItem"
                        @copy="copyItem"
                      >
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="
                                item.active ? 'text-primary' : 'text-danger'
                              "
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              class="success navi-text"
                              :class="
                                item.active ? 'text-primary' : 'text-danger'
                              "
                            >
                              {{
                                item.active ? 'Hoạt động' : 'Không hoạt động'
                              }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
export default {
  props: {},
  name: 'ServicePackageList',
  components: {
    'modal-import': () => import('./components/FormServicePackageImport.vue'),
  },
  data() {
    return {
      status: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {
        code: null,
        name: null,
        level: null,
        money: null,
        numberProgram: null,
        totalWeek: null,
        status: null,
      },
      sort: {
        by: null,
        order: null,
      },
      column: [
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
          class: 'text-start',
        },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          class: 'text-start',
        },
        {
          key: 'level',
          label: 'Cấp độ',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'money',
          label: 'Giá bán',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'numberProgram',
          label: 'Số lượng chương trình',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'totalWeek',
          label: 'Tổng số tuần',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          class: 'text-center',
        },
        {
          key: '',
          label: '',
          sortable: false,
          class: 'text-start',
        },
      ],
      data: [],
      loading: false,
      selectedItems: [],
    };
  },
  computed: {
    searchParams() {
      const payload = this.removeEmpty({
        code: this.filter.code,
        name: this.filter.name,
        level: this.filter.level,
        money: this.filter.money,
        numberProgram: this.filter.numberProgram,
        totalWeek: this.filter.totalWeek,
        status: this.filter.status,

        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      this.filter.code = null;
      this.filter.name = null;
      this.filter.level = null;
      this.filter.money = null;
      this.filter.numberProgram = null;
      this.filter.totalWeek = null;
      this.filter.status = null;

      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'service_package_view',
        params: {
          id: item.id,
        },
      });
    },
    editItem(item) {
      this.$router.push({
        name: 'service_package_edit',
        params: {
          id: item.id,
          form_type: 'edit',
        },
      });
    },
    // TODO: Lanh - If want to new sreen for insert
    // createItem() {
    //   this.$router.push({
    //     name: 'service_package_create',
    //   });
    // },
    getPositionClass(value) {
      if (value == 'money') {
        return 'text-right';
      }
      return (
        this.column.find((item) => item.key == value)?.class ?? 'text-center'
      );
    },
    createItem() {
      this.$router.push({
        name: 'service_package_edit',
        params: {
          form_type: 'create',
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$bvModal.show('modal-import');
    },
    deleteItem(item) {
      let btn = item.Status == 0 ? 'btn-active' : 'btn-inactive';
      let textStatusB = item.Status ? 'Hoạt động' : 'Không hoạt động';
      let textStatusA = !item.Status ? 'Hoạt động' : 'Không hoạt động';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusA} thành ${textStatusB} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    copyItem(item) {
      this.$router.push({
        name: 'service_package_detail',
        params: {
          form_type: 'copy',
          id: item.id,
        },
      });
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      // Create a new FormData object
      const formData = new FormData();
      // Append properties of the item object to formData
      Object.keys(item).forEach((key) => {
        if (key == 'status') {
          formData.append('status', item.status ? '0' : '1');
        } else formData.append(key, item[key]);
      });

      const res = await this.$api.put(`/ServicePackage/${item.id}`, formData);
      const { error } = res;
      if (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('ServicePackage', {
          params: this.searchParams,
        });
        this.data =
          data.items.map((el) => {
            return {
              ...el,
              //position:
              //  el.accountPositionMappings.length &&
              //  el.accountPositionMappings[0].position.name,
              //hospital: this.getDataHospital(
              //  el.accountRule?.accountRuleTagMappings || [],
              //),
            };
          }) || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (!status) return 'active';
      return 'inactive';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api
        .get('ServicePackage/PrepareSearchFormItem')
        // .then(({ data }) => {
        //   const { agencyList, genderList, positionList, statusList } = data;
        //   this.agencies = agencyList;
        //   this.positions = positionList;
        //   this.statuses = statusList;
        //   this.genders = genderList;
        // })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        });
    },
  },
  async created() {
    await Promise.all([this.loadData(), this.getSearchDataPrepare()]);
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 160px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
